import { Schema } from "@effect/schema";
import { Address, ChainKey } from "@silo/types";
import { Context } from "effect";

export type UserMarketAddresses = typeof UserMarketAddresses.Type;
export type UserMarketAddressesEncoded = typeof UserMarketAddresses.Encoded;

export const UserMarketAddresses = Schema.Struct({
  source: Schema.Literal("graph", "static"),
  marketAddresses: Schema.Array(Address),
}).annotations({ identifier: "UserMarketAddresses" });

export type RewardToken = typeof RewardToken.Type;
export type RewardTokenEncoded = typeof RewardToken.Encoded;

export const RewardToken = Schema.Struct({
  tokenAddress: Address,
  chainKey: ChainKey,
  symbol: Schema.String,
}).annotations({ identifier: "RewardToken" });

export interface Http {
  fetch: typeof fetch;
}

export class HttpService extends Context.Tag("HttpService")<
  HttpService,
  Http
>() {}
